import { render, staticRenderFns } from "./productOrdering.vue?vue&type=template&id=f7ccbca6&"
import script from "./productOrdering.vue?vue&type=script&lang=js&"
export * from "./productOrdering.vue?vue&type=script&lang=js&"
import style0 from "./productOrdering.vue?vue&type=style&index=0&id=f7ccbca6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports